import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginUri: '', // 登录链接
    wxLoginUri: '', // 微信登录链接
    findPwdByMobileUri: '', // 手机号码找回密码链接
    findPwdByWechatUri: '' // 微信找回密码链接
  },
  mutations: {
    setLoginUri (state, loginUri) {
      state.loginUri = loginUri
    },
    setWxLoginUri (state, wxLoginUri) {
      state.wxLoginUri = wxLoginUri
    },
    setFindPwdByMobileUri (state, findPwdByMobileUri) {
      state.findPwdByMobileUri = findPwdByMobileUri
    },
    setFindPwdByWechatUri (state, findPwdByWechatUri) {
      state.findPwdByWechatUri = findPwdByWechatUri
    }
  },
  actions: {
  },
  modules: {
  }
})
